// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_Cyub3","title":"title_GAsw-","default-icon":"default-icon_b9EiN"};